import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function favoriteFilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16.127 4a4.86 4.86 0 014.869 4.854 7.278 7.278 0 01-1.83 4.995 59.577 59.577 0 01-6.558 5.933 1 1 0 01-1.22 0 59.477 59.477 0 01-6.558-5.933A7.273 7.273 0 013 8.854a4.85 4.85 0 018.998-2.527A4.852 4.852 0 0116.128 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function favoriteUnfilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M18.997 8.854v.16a5.37 5.37 0 01-1.35 3.486 51.054 51.054 0 01-5.649 5.204 50.5 50.5 0 01-5.659-5.194 5.307 5.307 0 01-1.34-3.516v-.16a2.85 2.85 0 015.289-1.478c.55.81 1 1.259 1.71 1.259s1.21-.47 1.71-1.259a2.84 2.84 0 012.42-1.358 2.868 2.868 0 012.869 2.856zM16.127 4a4.85 4.85 0 00-4.129 2.327A4.85 4.85 0 003 8.854a7.278 7.278 0 001.83 4.995 59.577 59.577 0 006.558 5.933 1 1 0 001.22 0 59.577 59.577 0 006.559-5.933 7.287 7.287 0 001.83-4.995 4.852 4.852 0 00-1.428-3.436A4.864 4.864 0 0016.127 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function listAdd(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 11a1 1 0 011 1v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 011-1zM3.99 14h6.02a.99.99 0 01.99.99v.02a.99.99 0 01-.99.99H3.99a.99.99 0 01-.99-.99v-.02a.99.99 0 01.99-.99zM13 10a1 1 0 010 2H4a1 1 0 010-2h9zm0-4a1 1 0 010 2H4a1 1 0 010-2h9z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function listDone(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M20.703 14.281c.386.385.397 1.02.024 1.418l-4.807 5.02a.954.954 0 01-1.353 0l-2.257-2.205a1.028 1.028 0 01-.284-.967 1 1 0 01.671-.736.963.963 0 01.955.23l1.557 1.553 4.117-4.288a.954.954 0 011.377-.025zM10 14.012a1 1 0 010 2H4a1 1 0 110-2h6zm3-3.986a1 1 0 010 2H4a1 1 0 010-2h9zM13 6a1 1 0 010 2H4a1 1 0 010-2h9z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function listEdit(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.931 11.709l1.424 1.412-5.876 5.859-1.434.02.01-1.432 5.876-5.86zm-7.921 2.303a.99.99 0 01.99.99v.02a.99.99 0 01-.99.99H3.99a.99.99 0 01-.99-.99v-.02a.99.99 0 01.99-.99h6.02zm9.335-3.715a1.001 1.001 0 011.414 1.412l-.712.71-1.414-1.411zM13 10.027a1 1 0 110 2H4a1.001 1.001 0 010-2h9zM13 6a1 1 0 010 2H4a1 1 0 010-2h9z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function listRemove(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.998 8H4.002C3.449 8 3 7.552 3 7s.449-1 1.002-1h8.996C13.551 6 14 6.448 14 7s-.449 1-1.002 1zM11 12.002H4a1 1 0 010-2h7a1 1 0 010 2zM11.01 16H3.99c-.547 0-.99-.448-.99-1s.443-1 .99-1h7.02c.547 0 .99.448.99 1s-.443 1-.99 1zm7.88-2.501l1.873 1.873a.987.987 0 01-1.391 1.39L17.5 14.89l-1.724 1.727a.987.987 0 11-1.391-1.391l1.724-1.726-1.87-1.871a.988.988 0 01.05-1.34.988.988 0 011.34-.05l1.87 1.87 1.827-1.823a.987.987 0 011.39 1.391L18.89 13.5z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function listResort(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10.01 14.012a.99.99 0 01.99.99v.02a.99.99 0 01-.99.99H3.99a.99.99 0 01-.99-.99v-.02a.99.99 0 01.99-.99h6.02zm6.697-9.72c.39.391.39 1.025 0 1.415l-.308.309A5 5 0 0116 16a1 1 0 010-2 3 3 0 00.398-5.974l.318.326a1 1 0 11-1.432 1.396l-2-2.05a1 1 0 01.009-1.405l2-2a1 1 0 011.414 0zM13 10.027a1 1 0 010 2H4a1 1 0 010-2h9zM4 6h6a1 1 0 010 2H4a1 1 0 010-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function passwordHide(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.29 3.29a1.001 1.001 0 011.41 1.42l-16 15.996a1.004 1.004 0 01-1.42-1.42l2.47-2.469A13.44 13.44 0 012 11.998S5 5 12 5a9.767 9.767 0 014.5 1.08zM19 7.83a13.345 13.345 0 013 4.168s-3 6.998-10 6.998a9.808 9.808 0 01-3.55-.64l1.6-1.599c.634.159 1.286.24 1.94.24 4.35 0 6.83-3.42 7.74-4.999a11.357 11.357 0 00-2.15-2.759zm-3.16 3.169A3.942 3.942 0 0112 15.998a4.082 4.082 0 01-1-.17zm-3.85-4c-4.38 0-6.84 3.43-7.74 5a10.991 10.991 0 002.94 3.388l1.37-1.39A3.9 3.9 0 018 11.998 3.998 3.998 0 0112 8c.703.012 1.39.212 1.99.58l1-1a7.888 7.888 0 00-3-.58zm.01 3a2 2 0 00-2 2c.005.169.032.337.08.5l2.43-2.43a1.997 1.997 0 00-.51-.07z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function passwordReveal(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 5c7.1 0 10 7 10 7s-2.89 7-10 7c-7.11 0-10-7-10-7s3-7 10-7zm0 2c-4.38 0-6.84 3.43-7.74 5 .89 1.58 3.39 5 7.74 5s6.83-3.42 7.74-5c-.89-1.59-3.31-5-7.74-5zm0 1c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 2a2 2 0 10-.001 3.999A2 2 0 0012 10z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function smallStarFilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.885 5a.91.91 0 00-.848.57L9.631 8.88h-3.82a.819.819 0 00-.528 1.44l2.862 2.32L7.347 17a.82.82 0 001.297.83l3.241-2.43 3.221 2.41a.817.817 0 001.297-.83l-.808-4.36 2.922-2.33a.821.821 0 00-.528-1.44h-3.89l-1.386-3.28a.909.909 0 00-.828-.57z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function smallStarHalf(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.885 6.12l1.297 3.14.259.61h3.99l-2.494 2-.469.37.11.59.728 3.92-2.843-2.15-.598-.45.02-8.03zm0-1.12a.91.91 0 00-.848.57L9.631 8.88h-3.82a.819.819 0 00-.528 1.44l2.862 2.32L7.347 17a.82.82 0 001.297.83l3.241-2.43 3.221 2.41a.817.817 0 001.297-.83l-.808-4.36 2.922-2.33a.821.821 0 00-.528-1.44h-3.89l-1.386-3.28a.909.909 0 00-.828-.57z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function smallStarUnfilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.885 6.12l1.297 3.14.259.61h3.99l-2.494 2-.469.37.11.59.728 3.92-2.843-2.15-.598-.45-.598.45-2.853 2.14.728-3.92.11-.59-.459-.37-2.453-2h3.99l.258-.61 1.297-3.13zm0-1.12a.91.91 0 00-.848.57L9.631 8.88h-3.82a.819.819 0 00-.528 1.44l2.862 2.32L7.347 17a.82.82 0 001.297.83l3.241-2.43 3.221 2.41a.817.817 0 001.297-.83l-.808-4.36 2.922-2.33a.821.821 0 00-.528-1.44h-3.89l-1.386-3.28a.909.909 0 00-.828-.57z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function starFilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.97 3a1.18 1.18 0 00-1.11.74L9.059 8.07H4.104a1.06 1.06 0 00-1.044.714c-.155.443-.004.937.37 1.216l3.726 3-1.06 5.71c-.067.318.014.649.218.9a1.057 1.057 0 001.466.17l4.19-3.18 4.18 3.15a1.047 1.047 0 001.458-.171c.203-.247.286-.573.227-.889L16.775 13l3.794-3c.375-.28.526-.773.37-1.216a1.06 1.06 0 00-1.043-.714h-5.033L13.07 3.75a1.18 1.18 0 00-1.1-.75z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function starHalf(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.896 8.063h-5.033L13.07 3.74c-.187-.448-.623-.74-1.105-.74s-.917.292-1.104.74L9.058 8.063H4.104a1.06 1.06 0 00-1.044.714c-.155.444-.004.938.37 1.217l3.726 3.002-1.06 5.713c-.067.318.014.65.218.9a1.055 1.055 0 001.466.171l4.19-3.182 4.18 3.152c.183.141.405.218.635.22.318 0 .62-.144.823-.391a1.09 1.09 0 00.227-.89l-1.06-5.693 3.794-3.002c.375-.28.526-.773.37-1.217a1.058 1.058 0 00-1.043-.714zM11.97 6.252l1.585 3.822h3.686l-2.626 2.101.842 4.563-3.487-2.632V6.252z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function starUnfilled(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.896 8.063h-5.033L13.07 3.74c-.187-.448-.623-.74-1.105-.74s-.917.292-1.104.74L9.058 8.063H4.104a1.06 1.06 0 00-1.044.714c-.155.444-.004.938.37 1.217l3.726 3.002-1.06 5.713c-.067.318.014.65.218.9a1.055 1.055 0 001.466.171l4.19-3.182 4.18 3.152c.183.141.405.218.635.22.318 0 .62-.144.823-.391a1.09 1.09 0 00.227-.89l-1.06-5.693 3.794-3.002c.375-.28.526-.773.37-1.217a1.058 1.058 0 00-1.043-.714zm-5.28 4.102l.841 4.563-3.487-2.622-3.497 2.632.832-4.553-2.585-2.12h3.655l1.595-3.813 1.585 3.822h3.686l-2.626 2.091z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function viewGrid(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M6.136 5.1h3.928c.572 0 1.036.464 1.036 1.036v3.928c0 .572-.464 1.036-1.036 1.036H6.136A1.036 1.036 0 015.1 10.064V6.136c0-.572.464-1.036 1.036-1.036zm8.004 0h3.92c.574 0 1.04.466 1.04 1.04v3.92a1.04 1.04 0 01-1.04 1.04h-3.92a1.04 1.04 0 01-1.04-1.04V6.14c0-.574.466-1.04 1.04-1.04zm-8.004 8h3.928c.572 0 1.036.464 1.036 1.036v3.928c0 .572-.464 1.036-1.036 1.036H6.136A1.036 1.036 0 015.1 18.064v-3.928c0-.572.464-1.036 1.036-1.036zm8.002 0h3.924c.573 0 1.038.465 1.038 1.038v3.924c0 .573-.465 1.038-1.038 1.038h-3.924a1.038 1.038 0 01-1.038-1.038v-3.924c0-.573.465-1.038 1.038-1.038z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function viewList(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M4 15.1a1 1 0 110 2 1 1 0 010-2zm16-.1a1 1 0 010 2H8a1 1 0 010-2h12zM4 11a1 1 0 110 2 1 1 0 010-2zm16 0a1 1 0 010 2H8a1 1 0 010-2h12zM4 7a1 1 0 110 2 1 1 0 010-2zm16 0a1 1 0 010 2H8a1 1 0 010-2h12z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}
